import React from "react"
import { useTranslation } from "react-i18next"
import { ModalBody } from "reactstrap"
import { BaseModal, CloseIcon, IModalBase, IModalControlProps } from "swiipe.portal.shared"
import "./ModalIframe.scss"

export interface IModalIframe extends IModalBase {
    type: "iframe"
    src: string
}

const ModalIframe = ({ callback, src, ...otherProps }: IModalIframe & IModalControlProps) => {
    const { t } = useTranslation()

    return (
        <BaseModal {...otherProps} callback={callback} size="xl" id="iframe-modal" centered>
            <ModalBody>
                <iframe src={src} />
                <div className="iframe-modal__close-container">
                    <CloseIcon className="iframe-modal__close-cross" onClick={() => callback("ignored")} />
                </div>
            </ModalBody>
        </BaseModal>
    )
}

export default ModalIframe
